import { useCallback } from 'react';
import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const getNextEquipmentNumber = async (num?: string): Promise<string> => {
  const ifUsed = num ? `?used=${num}` : '';
  return fetchFromOldApi(`/json/employee/equipment/nextnumber${ifUsed}`).then(
    (r) => r.json(),
  );
};

type UseGetNextEquipmentNumberOutput = UseSWROutput<string> & {
  updateUsedEquipmentNumber: (number: string) => Promise<string | undefined>;
};

export const useGetNextEquipmentNumber = (
  swrConfig?: SWRConfiguration<string>,
): UseGetNextEquipmentNumberOutput => {
  const { mutate, ...rest } = useSWR(
    ['getNextEquipmentNumber'],
    () => getNextEquipmentNumber(),
    swrConfig,
  );

  const updateUsedEquipmentNumber = useCallback(
    async (number: string): Promise<string | undefined> => {
      return getNextEquipmentNumber(number).then((newNumber) => {
        mutate();
        return newNumber;
      });
    },
    [mutate],
  );

  return {
    updateUsedEquipmentNumber,
    mutate,
    ...rest,
  };
};
